import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as DelegationsStore from 'src/app/delegations/store';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(DelegationsStore.delegationsFeatureKey, DelegationsStore.delegationsReducer),
        EffectsModule.forFeature([DelegationsStore.DelegationsEffects])
    ]
})
export class DelegationsStoreModule {}
